import { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import { Space } from "antd";
import { useSelector } from "react-redux";

/* social media  */
import CMSPill from "../../Common/Components/CMSPill";
import { getImageUrl } from "../../../utils";
import CuratedPill from "./CuratedPill";
import { removeFavoriteArticle } from "modules/Content/Favorites/actions";
import FavouriteIcon from "../../Common/Components/ArticleFavouriteIcon";

const SuccessCheckBlogItem = (props) => {
  const {
    articleId,
    title,
    website,
    tags,
    publishDate,
    smallBlog,
    imgUrl,
    imgHeight,
    isFav,
    isCMS,
    is_loading,
    is_removingFailed,
    isCurated,
    companyLogo,
    isBeingDragged,
    selectedArticle,
    preview,
    isDraggable,
  } = props;
  const [imgWidth, setimgWidth] = useState({});
  const imgDiv = useRef(null);
  const selectedArticles = useSelector((state) => state.dragDrop.selectedIds);
  const [isChecked, SetIsChecked] = useState(preview || selectedArticles.includes(articleId) ? true : isDraggable);
  useEffect(() => {
    SetIsChecked(selectedArticles.includes(articleId));
  }, [selectedArticles]);

  useEffect(() => {
    if (imgDiv.current) {
      let width = imgDiv.current.offsetWidth;
      setimgWidth(width);
    }
  }, []);

  return (
    <BlogItemWrapper
      id={articleId ? articleId : "CheckBlogItem"}
      isChecked={isChecked}
      isBeingDragged={isBeingDragged}
      SmallBlog={smallBlog}
      isPreview={preview} // for setting small sizes and checking if being dragged
    >
      <div
        className={`wrapper-blog ${is_loading ? "disabled" : ""} ${is_removingFailed ? "remove-failed" : ""} ${
          isChecked ? "checked" : ""
        }`}
      >
        <div className="img-div" ref={imgDiv}>
          <img
            src={getImageUrl(imgUrl, imgWidth, imgHeight, articleId)}
            alt=""
            className="img-responsive"
            style={preview ? {} : { height: imgHeight + "px", width: "100%" }}
          />
        </div>
        <div className="banner-left-icons">
          <Space size="small">
            {isFav && (
              <i style={{ cursor: "pointer" }} onClick={() => removeFavoriteArticle(articleId)}>
                <FavouriteIcon />
              </i>
            )}
            {isCMS && <CMSPill />}
          </Space>
        </div>
        {isCurated && (
          <div className="curated-pill-wrapper">
            <CuratedPill />
          </div>
        )}
        {/*  curated article count */}
        {isBeingDragged && selectedArticle > 1 && <div className="article-count-circle">3</div>}
        <div className="content-div-wrapper" style={{ position: "relative" }}>
          {isBeingDragged && selectedArticle > 1 && (
            <>
              {/* second layered content div */}
              <div className="content-div  content-layered-1">
                <div className="content">
                  <h4 className="title">{title}</h4>
                  <div className="desc">
                    <span className="website-link padding-sm">{website} |</span>
                    <span className="published-time padding-sm">{publishDate}|</span>
                    <span className="tags padding-sm">{tags}</span>
                  </div>
                </div>
                <div className="Blog-menu-icon">
                  {companyLogo ? (
                    <div className="company-logo">
                      <img src={companyLogo} alt="logo" />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {/* second layered div ends here */}
            </>
          )}

          <div className="content-div">
            <div className="content">
              <h4 className="title">{title}</h4>
              <div className="desc">
                <span className="website-link padding-sm">{website} |</span>
                <span className="published-time padding-sm">{publishDate} |</span>
                <span className="tags padding-sm">{tags}</span>
              </div>
            </div>
            <div className="Blog-menu-icon">
              {companyLogo ? (
                <div className="company-logo">
                  <img src={companyLogo} alt="logo" />
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    </BlogItemWrapper>
  );
};
export default SuccessCheckBlogItem;

SuccessCheckBlogItem.defaultProps = {
  // imgUrl: "",
  imgUrl:
    "https://image.freepik.com/free-photo/abstract-surface-textures-white-concrete-stone-wall_74190-8184.jpg",

  title: "Article title goes here and can be up to two lines long if",
  website: "forbes.com",
  publishDate: "2 min ago",
  tags: "Design, Strategy",
  smallBlog: false,
};

const BlogItemWrapper = styled.div`
  height: 100%;
  width: 70px;
  .checked {
    box-shadow: ${(props) => (props.isPreview ? "0 0 0 3px #27CE0A !important" : "0 0 0 4px #27CE0A !important")};
  }
  .wrapper-blog  ${(props) =>
    !props.isPreview
      ? `{
    position: relative;
    z-index: 1;
    .curated-pill-wrapper {
      position: absolute;
      top: 15px;
      right: 15px;
      z-index: 1;
    }
    .article-count-circle {
      z-index: 1;
      height: 60px;
      width: 60px;
      background-color: #27ce0a;
      position: absolute;
      top: -15px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 5px;
      right: -15px;
      color: #fff;
    }
    background-color: #fff;
    box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 12px;
    position: relative;
    height: 100%;
    .img-div {
      img {
        min-width: 100%;
        border: ${props.isBeingDragged ? "solid 2px #27ce0a" : "none"};
        position: relative;
        border-bottom: none;
        z-index: 1;
        height: 35px;
        max-width: 100%;
      }
      .layered-img-1 {
        position: absolute;
        left: -11px;
        border: solid 5px #27ce0a;
        border-bottom: none;
        top: 10px;
      }
      .layered-img-2 {
        position: absolute;
        left: -20px;
        border: solid 4px #27ce0a;
        border-bottom: none;
        top: 23px;
      }
    }
    .add-icon {
      position: absolute;
      top: 15px;
      right: 15px;
      :hover {
        cursor: pointer;
      }
    }
    .banner-left-icons {
      display: flex;
      position: absolute;
      top: 15px;
      left: 15px;
      padding-top: 3px;
      z-index: 1;
      .article-fav-icon {
      }
      .content-engagement-pill-wrapper {
        margin-left: 4px;
        margin-right: 4px;
      }
    }
    .content-div {
        height: 18px;
        padding: 3px;
      border: ${props.isBeingDragged ? "solid 4px #27ce0a" : "none"};
      position: relative;
      z-index: 1;
      border-top: none;
      background-color: #fff;
      display: flex;
      .content {
        display: flex;
        flex-direction: column;
    
      }
      .title {
        font-family: roboto_slabregular, sans-serif;
        font-size: 3px;
        color: #424b50;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-bottom: 0;
       }
      .desc {
        display: flex;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        .website-link {
          color: #db3725;
          font-family: "robotomedium", sans-serif;
          font-size: 2px;
          padding-left: 0;
        }
        .published-time {
          color: #7e7e7e;
          font-size: 2px;
          font-family: "robotomedium", sans-serif;
          font-weight: 400;
        }
        .tags {
          color: #27CE0A;
          font-family: "robotomedium", sans-serif;
          font-weight: 400;
          font-size: 2px;
        }
      }
      .Blog-menu-icon {
        align-self: flex-end;
        > div {
          cursor: pointer;
          img {
              height: 4px;
            .ant-popover .ant-popover-content .ant-popover-inner {
              border-radius: 10px;
            }
          }
        }
        .company-logo {
          align-self: flex-end;
          cursor: default;
          margin-bottom: -20px;
          padding-top: 20px;
          img {
            max-width: 40px;
          }
        }
      }
    }
    .content-layered-1 {
      position: absolute;
      top: 10px;
      background-color: #fff;
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
      border: solid 4px #27ce0a;
      left: -11px;
      border-top: none;
      margin-right: 10px;
    }
    .content-layered-2 {
      position: absolute;
      top: 22px;
      background-color: #fff;
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
      border: solid 4px #27ce0a;
      left: -20px;
      border-top: none;
      margin-right: 20px;
    }
  } 
`
      : `
  {
    border:  solid 3px #27ce0a;
    position: relative;
    z-index: 1;
    background-color: #fff;
    box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 12px;
    position: relative;
    height: 100%;
    .curated-pill-wrapper {
      position: absolute;
      top: 5px;
      right: 5px;
      z-index: 1;
    }
    .article-count-circle {
      z-index: 2;
      height: 40px;
      width: 40px;
      background-color: #27ce0a;
      position: absolute;
      top: -5px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 49px;
      right: -15px;
      color: #fff;
    }
    .img-div {
      height: 90px;
      img {
        height: 100%;
        min-width: 100%;
        border-bottom: none;
        z-index: 1;
        max-width: 100%;
      }
    }
    .banner-left-icons {
      display: flex;
      position: absolute;
      top: 5px;
      left: 5px;
      padding-top: 3px;
      z-index: 1;
      .article-fav-icon {

      }
      .content-engagement-pill-wrapper {
        margin-left: 2px;
        margin-right: 2px;
      }
    }
    .content-div-wrapper {
      position: relative;
      // border: 2px solid #27ce0a;
      height: 75px;
      border-top: none;
      .content-div {
          height: 18px;
          padding: 3px;
        // border: ${props.isBeingDragged ? "solid 2px #27ce0a" : "none"};
        position: relative;
        z-index: 1;
        border-top: none;
        background-color: #fff;
        display: flex;
        padding: 0.6rem 0.9rem;

        .content {
          display: flex;
          flex-direction: column;
          padding-right: 14px;
        }
        .title {
          font-family: roboto_slabregular,sans-serif;
          font-size: 3px;
          color: #424b50;
          min-height: 30px;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          font-weight: bold;
          margin: 0;
          margin-bottom: 0px;
        }
        .desc {
          display: flex;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          .website-link {
            color: #db3725;
            font-family: "robotomedium", sans-serif;
            font-size: 2px;
            padding-left: 0;
          }
          .published-time {
            color: #7e7e7e;
            font-size: 2px;
            font-family: "robotomedium", sans-serif;
            font-weight: 400;
          }
          .tags {
            color: #27CE0A;
            font-family: "robotomedium", sans-serif;
            font-weight: 400;
            font-size: 2px;
          }
        }
        .Blog-menu-icon {
          align-self: start;
          > div {
            cursor: pointer;
            img {
              .ant-popover .ant-popover-content .ant-popover-inner {
                border-radius: 10px;
              }
            }
          }
          .company-logo {
            align-self: flex-end;
            cursor: default;
            margin-bottom: -20px;
            padding-top: 20px;
            img {
              max-width: 40px;
            }
          }
        }
      }
    }
  }
  `};
  .disabled {
    pointer-events: none;

    /* for "disabled" effect */
    background: #ccc;
  }
  .remove-failed {
    /* for "disabled" effect */
    opacity: 1;
    background: #facfcf;
  }
  .layer-1 {
    position: absolute;
    top: 0;
    left: -5px;
    border: solid 2.5px #27CE0A;
    z-index: 1;
  }
`;

const BlogItemPreviewWrapper = styled.div`
  height: 100%;
  .wrapper 
`;
